import { Button, ButtonProps } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { SearchItem } from '../searchTypes'
import SearchResultContent from './SearchResultContent'
import { getSearchResultTitle } from './searchResultUtils'

type TreeTitle = ReturnType<typeof getSearchResultTitle>

interface Props extends ButtonProps {
  item?: SearchItem
  prevItem?: SearchItem
  standalone?: boolean
  // Title and depth computed by the list for the whole group (#123), rather
  // than from the previous result.
  tree?: TreeTitle
  highlighted?: boolean
}

export default React.forwardRef<HTMLButtonElement, Props>(
  function SearchResultButton(
    { item, prevItem, standalone, tree, highlighted, ...buttonProps },
    ref
  ) {
    const { title, depth } = useMemo(
      () => tree ?? getSearchResultTitle(item, prevItem, standalone),
      [tree, item, prevItem, standalone]
    )

    return (
      <Button
        isActive={highlighted}
        ref={ref}
        pointerEvents="auto"
        justifyContent="start"
        variant="solid"
        py={2}
        pl={`calc(var(--chakra-sizes-3) + ${depth * 20}px)`}
        {...buttonProps}
      >
        <SearchResultContent
          item={item}
          size={buttonProps?.size as string}
          title={title}
        />
      </Button>
    )
  }
)
